<!-- 高级认证 -->
<template>
    <div class="main-box">
        <div class="content-main">
            <div class="top-info">
                <a-button @click="goBack">
                    <template #icon>
                        <icon-left />
                    </template>
                </a-button>
                <span>{{ $t('personal.level_two_advanced_verification') }}</span>
            </div>
            <div class="recommendInvite-content">
                <!-- 加载状态 -->
                <div v-if="isLoading" class="loading-container" style="text-align: center; padding: 50px;">
                    <a-spin size="large" />
                    <p>{{ $t('common.loading') }}</p>
                </div>
                
                <!-- 认证状态显示 -->
                <div v-else-if="authStatus !== null" class="auth-status-container" style="text-align: center; padding: 50px;">
                    <div class="status-card" style="max-width: 500px; margin: 0 auto;">
                        <div v-if="authStatus === 0" class="status-pending">
                            <div class="status-icon">
                                <icon-clock-circle size="64" style="color: #ff9e2d;"/>
                    </div>
                            <h2 class="status-title">{{ $t('personal.verification_pending') }}</h2>
                            <p class="status-desc">{{ $t('personal.verification_pending_desc') }}</p>
                            <div class="status-tips">
                                <icon-info-circle size="16" style="color: #ff9e2d; margin-right: 8px;"/>
                                <span>{{ $t('personal.review_completion_time') }}</span>
                    </div>
                </div>
                        <div v-else-if="authStatus === 1" class="status-approved">
                            <div class="status-icon">
                                <icon-check-circle size="64" style="color: #52c41a;"/>
                                        </div>
                            <h2 class="status-title">{{ $t('personal.verification_approved') }}</h2>
                            <p class="status-desc">{{ $t('personal.verification_approved_desc') }}</p>
                            <div class="status-tips">
                                <icon-check-circle size="16" style="color: #52c41a; margin-right: 8px;"/>
                                <span>{{ $t('personal.higher_withdrawal_limit_obtained') }}</span>
                                        </div>
                                    </div>
                        <div v-else-if="authStatus === 2" class="status-rejected">
                            <div class="status-icon">
                                <icon-close-circle size="64" style="color: #ff4d4f;"/>
                            </div>
                            <h2 class="status-title">{{ $t('personal.verification_rejected') }}</h2>
                            <p class="status-desc">{{ $t('personal.verification_rejected_desc') }}</p>
                            <div class="reject-reason" v-if="authInfo && authInfo.reject_reason">
                                <div class="reason-box">
                                    <strong>{{ $t('personal.verification_rejection_reason') }}:</strong>
                                    <span>{{ authInfo.reject_reason }}</span>
                                </div>
                            </div>
                            <div class="action-buttons">
                                <a-button type="primary" size="large" @click="resetForm">
                                    <template #icon>
                                        <icon-refresh />
                            </template>
                                    {{ $t('personal.resubmit') }}
                                </a-button>
                                    </div>
                                </div>
                    </div>
                </div>
                

                
                <!-- 认证表单 -->
                <div v-else>
                    <div class="box" v-if="step == 1">
                        <div class="content-container">
                            <h2 class="page-title">{{ $t('personal.portrait_video') }}</h2>
                            
                            <div class="upload-container">
                                <input 
                                    type="file" 
                                    ref="fileInput" 
                                    accept="video/*" 
                                    style="display: none;"
                                    @change="handleFileSelect"
                                />
                                <div class="upload-button" @click="triggerFileSelect">
                                    <div class="upload-icon">
                                        <icon-video-camera size="32"/>
                                        <div class="play-icon">
                                            <icon-play-circle-fill size="24"/>
                                        </div>
                                    </div>
                                    <p>{{ $t('personal.click_upload_video') }}</p>
                                </div>
                                <div v-if="file" class="file-preview">
                                    <p>{{ $t('personal.file_selected') }}: {{ file.name }}</p>
                    </div>
                    </div>
                            
                    <div class="dsc">
                        <div class="title">{{ $t('personal.upload_requirements') }}</div>
                                <div class="ms"> {{ $t('personal.video_format_requirement') }}</div>
                                <div class="ms"> {{ $t('personal.video_portrait_requirement') }}</div>
                            </div>
                            
                            <div class="submit-section">
                                <a-botton class="model-content-footer-btn2" @click="submitForm" :loading="isSubmitting" :disabled="isSubmitting || !isVideoUploaded">
                                    {{ isSubmitting ? $t('common.loading') : $t('personal.submit_verification') }}
                                </a-botton>
                            </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userApi from '@/common/api/user.js';
import config from '@/common/api/config.js';

export default {
    components: {
    },
    data() {
        return {
            name: 'seniorAuth',
            step: 1,
            file: null,

            // 提交状态
            isSubmitting: false,
            // 认证状态
            authStatus: null, // null=未认证, 0=审核中, 1=已通过, 2=已拒绝
            authInfo: null, // 认证信息
            isLoading: true // 加载状态
        };
    },
    mounted() {
        console.log('高级认证组件挂载');
        // 获取认证状态
        this.getAuthStatus();
    },
    computed: {
        // 检查视频是否已上传
        isVideoUploaded() {
            return !!(this.file && this.file.url);
        }
    },
    watch: {
        // 监听语言变化
        '$i18n.locale'() {
            // 强制重新渲染组件
            this.$forceUpdate();
        }
    },
    methods: {
        goBack() {
            this.$emit("safet-event");
        },
        onChange(info) {
            console.log('📁 文件变化:', info);
            
            // 检查info和info.file是否存在
            if (!info || !info.file) {
                console.log('ℹ️ 文件信息不完整:', info);
                return;
            }
            
            // 添加更详细的调试信息
            console.log('📁 文件详细信息:', {
                uid: info.file.uid,
                name: info.file.name,
                status: info.file.status,
                response: info.file.response,
                url: info.file.url
            });
            
            if (info.file.status === 'done') {
                // 上传成功
            this.file = {
                    uid: info.file.uid,
                    name: info.file.name,
                    url: info.file.response?.data?.url || info.file.url,
                    status: 'done'
                };
                console.log('✅ 文件上传完成:', this.file);
            } else if (info.file.status === 'error') {
                // 上传失败
                console.error('❌ 文件上传失败:', info.file);
                this.$message.error(this.$t('personal.video_upload_failed'));
                this.file = null; // 重置文件状态
            } else {
                // 其他状态（如uploading等）
                console.log('📤 文件上传状态:', info.file.status);
            }
        },
        triggerFileSelect() {
            this.$refs.fileInput.click();
        },
        async handleFileSelect(event) {
            const selectedFile = event.target.files[0];
            if (!selectedFile) {
                return;
            }
            
            console.log('📤 选择的文件:', selectedFile);
            
            // 检查文件大小
            if (selectedFile.size > 10 * 1024 * 1024) {
                this.$message.error(this.$t('personal.video_file_size_exceeded'));
                return;
            }
            
            // 检查文件类型
            if (!selectedFile.type.startsWith('video/')) {
                this.$message.error(this.$t('personal.please_select_video'));
                return;
            }
            
            try {
                // 创建FormData
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('type', 'video');
                
                // 获取认证信息
                const token = this.$util.getCache('token', '');
                const lang = this.$util.getCache('lang', 'en-US');
                
                // 发送上传请求
                const response = await fetch(`${config.BASE_URL}/api/upload/image`, {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Accept-Language': lang,
                        'Client-Device': '0'
                    },
                    body: formData
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                if (result.code === 200) {
                    console.log('✅ 视频上传成功:', result);
                    // 设置文件信息
                    this.file = {
                        uid: Date.now(),
                        name: selectedFile.name,
                        url: result.data?.url || result.url,
                        status: 'done'
                    };
                    this.$message.success(this.$t('personal.video_upload_success'));
                } else {
                    console.error('❌ 视频上传失败:', result);
                    this.$message.error(result.message || this.$t('personal.upload_failed'));
                }
            } catch (error) {
                console.error('❌ 视频上传错误:', error);
                this.$message.error(this.$t('personal.video_upload_failed'));
            }
        },
        async beforeUpload(file) {
            console.log('📤 beforeUpload 接收到的文件:', file);
            
            try {
                // 检查文件是否存在
                if (!file) {
                    throw new Error('文件对象为空');
                }
                
                // 创建FormData
                const formData = new FormData();
                formData.append('file', file);
                formData.append('type', 'video');
                
                // 添加调试信息
                console.log('📁 文件信息:', {
                    name: file?.name || '未知文件名',
                    size: file?.size || 0,
                    type: file?.type || '未知类型',
                    lastModified: file?.lastModified || 0
                });
                
                // 获取认证信息
                const token = this.$util.getCache('token', '');
                const lang = this.$util.getCache('lang', 'en-US');
                
                // 发送上传请求
                const response = await fetch(`${config.BASE_URL}/api/upload/image`, {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Accept-Language': lang,
                        'Client-Device': '0'
                    },
                    body: formData
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                if (result.code === 200) {
                    console.log('✅ 视频上传成功:', result);
                    // 设置文件信息
                    this.file = {
                        uid: file.uid || Date.now(),
                        name: file.name,
                        url: result.data?.url || result.url,
                        status: 'done'
                    };
                    return false; // 阻止默认上传行为
                } else {
                    console.error('❌ 视频上传失败:', result);
                    this.$message.error(result.message || this.$t('personal.upload_failed'));
                    return false;
                }
            } catch (error) {
                console.error('❌ 视频上传错误:', error);
                this.$message.error(this.$t('personal.video_upload_failed'));
                return false;
            }
        },
        async customUpload(options) {
            console.log('📤 customUpload 接收到的参数:', options);
            
            // 检查options参数
            if (!options) {
                throw new Error('customUpload 参数为空');
            }
            
            // 尝试不同的参数解构方式
            const file = options.file || options.data?.file || options;
            const onProgress = options.onProgress || (() => {});
            const onSuccess = options.onSuccess || (() => {});
            const onError = options.onError || (() => {});
            
            try {
                console.log('📤 开始上传视频文件:', file);
                
                // 检查文件是否存在
                if (!file) {
                    console.error('❌ 文件对象为空，options:', options);
                    throw new Error('文件对象为空');
                }
                
                // 创建FormData
                const formData = new FormData();
                formData.append('file', file); // 使用标准的'file'字段名
                formData.append('type', 'video'); // 添加文件类型标识
                
                // 添加调试信息
                console.log('📁 文件信息:', {
                    name: file?.name || '未知文件名',
                    size: file?.size || 0,
                    type: file?.type || '未知类型',
                    lastModified: file?.lastModified || 0
                });
                
                // 获取认证信息
                const token = this.$util.getCache('token', '');
                const lang = this.$util.getCache('lang', 'en-US');
                
                // 发送上传请求
                const response = await fetch(`${config.BASE_URL}/api/upload/image`, {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Accept-Language': lang,
                        'Client-Device': '0'
                        // 注意：不要设置Content-Type，让浏览器自动设置multipart/form-data
                    },
                    body: formData
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                if (result.code === 200) {
                    console.log('✅ 视频上传成功:', result);
                    onSuccess(result);
                } else {
                    console.error('❌ 视频上传失败:', result);
                    onError(new Error(result.message || '上传失败'));
                }
            } catch (error) {
                console.error('❌ 视频上传错误:', error);
                onError(error);
            }
        },





        async getAuthStatus() {
            try {
                console.log('🔍 获取高级认证状态...');
                const response = await userApi.advancedAuthInfo();
                
                if (response && response.code === 200) {
                    this.authInfo = response.data;
                    // 使用新的video_status字段
                    this.authStatus = response.data.video_status || null;
                    
                    console.log('✅ 高级认证状态获取成功:', {
                        video_status: this.authStatus,
                        video_url: response.data.video_url,
                        info: this.authInfo
                    });
            } else {
                    console.log('ℹ️ 未找到高级认证信息，可能是首次认证');
                    this.authStatus = null;
                    this.authInfo = null;
                }
            } catch (error) {
                console.error('❌ 获取高级认证状态失败:', error);
                this.authStatus = null;
                this.authInfo = null;
            } finally {
                this.isLoading = false;
            }
        },


        async submitForm() {
            if (this.isSubmitting) {
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                // 验证视频文件
                if (!this.file || !this.file.url) {
                    this.$message.error(this.$t('personal.please_upload_video'));
                    return;
                }
                
                // 高级认证只需要视频URL，不需要获取其他用户信息
                console.log('📤 准备提交高级认证数据...');
                
                console.log('📤 准备提交高级认证数据...');
                
                console.log('📤 准备提交高级认证数据...');
                
                // 准备提交的数据 - 使用url字段（手机端模式）
                const submitData = {
                    url: this.file.url
                };
                
                console.log('提交视频认证数据:', submitData);
                console.log('视频URL:', this.file.url);
                
                // 调用高级认证API提交数据 - 使用/api/user/authHight接口
                const response = await userApi.submitHightAuth(submitData);
                
                if (response && response.code === 200) {
                    this.$message.success(this.$t('personal.verification_submit_success'));
                    
                    // 提交成功后立即更新状态
                    console.log('✅ 提交成功，开始更新状态...');
                    console.log('🔍 完整提交响应:', response);
                    console.log('🔍 response.data:', response.data);
                    console.log('🔍 response.data.data:', response.data?.data);
                    console.log('🔍 检查img3字段是否更新...');
                    
                    // 手动更新本地状态为待审核
                    console.log('🔄 手动更新hstatus为0...');
                    this.authStatus = 0;
                    
                    // 更新认证信息 - 只更新hstatus字段
                    this.authInfo = {
                        ...this.authInfo,
                        hstatus: 0,
                        img3: this.file.url
                    };
                    
                    console.log('✅ 本地状态已更新:', {
                        authStatus: this.authStatus,
                        authInfo: this.authInfo
                    });
                    
                    // 强制重新获取认证状态以确保数据同步
                    setTimeout(async () => {
                        try {
                            console.log('🔄 重新获取认证状态...');
                            await this.getAuthStatus();
                            
                            // 检查重新获取的状态
                            console.log('🔍 重新获取后的状态:', {
                                authStatus: this.authStatus,
                                authInfo: this.authInfo
                            });
                            console.log('🔍 重新获取后的img3字段:', this.authInfo?.img3);
                        } catch (error) {
                            console.warn('⚠️ 重新获取认证状态失败:', error);
                        }
                        
                        // 返回身份认证页面
                        this.goBack();
                    }, 1500);
                } else {
                    this.$message.error(response?.message || this.$t('common.failed'));
                }
            } catch (error) {
                console.error('提交认证失败:', error);
                this.$message.error(this.$t('common.failed'));
            } finally {
                this.isSubmitting = false;
            }
        },
        resetForm() {
            // 重置数据
            this.step = 1;
            this.file = null;
            this.authStatus = null;
            this.authInfo = null;
            this.isSubmitting = false;
            
            console.log('✅ 高级认证表单已重置');
        }
    },
};
</script>

<style lang="scss" scoped>
@import "./seniorAuth.scss";
</style>
  
